/** Group and enhanced-group parkers. Not two per spot. */
export const GROUP_PARKER_VEHICLE_LIMIT = 2;

export function maxVehiclesOnSubscription( isGroup: boolean, isEnhancedGroup: boolean, spots: number ): number {
    if( isGroup || isEnhancedGroup )
        return GROUP_PARKER_VEHICLE_LIMIT;
    return Math.max( 0, spots ) * 2;
}
